import { Headers, Request, RequestMethod, RequestOptions, Response, ResponseContentType } from '@angular/http';

import { ApiResponse } from '../models/api-response.model';
import { AuthHttp } from 'angular2-jwt';
import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { NotifierMessageType } from '../notifier/notifier.model';
import { NotifierService } from '../notifier/notifier.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable()
export class GlobalService {

  private apiUrl = environment.apiBaseUrl;

  constructor(public authHttp: AuthHttp,
    private notifierService: NotifierService,
    private authenticationService: AuthenticationService,
    private router: Router) {

  }

  public post(url: string, data: any): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Post,
      url: this.buildApiUrl(url),
      headers: this.initHeaders()
    });
    if (data !== null) {
      requestoptions.body = JSON.stringify(data);
    }
    return this.executeRequest(requestoptions);
  }

  public postFile(url: string, data: any, headers: any): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Post,
      url: this.buildApiUrl(url),
      headers: headers
    });

    if (data !== null) {
      requestoptions.body = data
    }

    return this.executeRequest(requestoptions);
  }

  public search(url: string, params: URLSearchParams): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Get,
      url: this.buildApiUrl(url),
      headers: this.initHeaders(),
      search: params
    });
    return this.executeRequest(requestoptions);
  }

  public get(url: string): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Get,
      url: this.buildApiUrl(url),
      headers: this.initHeaders()
    });
    return this.executeRequest(requestoptions);
  }

  public getWithParams(url: string, params: any): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Get,
      url: this.buildApiUrl(url),
      headers: this.initHeaders(),
      params: params
    });
    return this.executeRequest(requestoptions);
  }

  public file(url: string, data: any, headers: Headers): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Get,
      url: this.buildApiUrl(url),
      headers: headers,
      responseType: ResponseContentType.Blob
    });
    if (data !== null) {
      requestoptions.body = JSON.stringify(data);
    }
    return this.executeRequest(requestoptions);
  }

  public put(url: string, data: any): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Put,
      url: this.buildApiUrl(url),
      headers: this.initHeaders()
    });
    if (data) {
      requestoptions.body = JSON.stringify(data);
    }
    return this.executeRequest(requestoptions);
  }

  public delete(url: string): Observable<ApiResponse> {
    const requestoptions = new RequestOptions({
      method: RequestMethod.Delete,
      url: this.buildApiUrl(url),
      headers: this.initHeaders()
    });
    return this.executeRequest(requestoptions);
  }

  private executeRequest(requestoptions: RequestOptions): Observable<ApiResponse> {
    return this.authHttp.request(new Request(requestoptions))
      .do((res: Response) => console.log('HTTP (options, res) ->', requestoptions, res))
      .map((res: Response) => {
        return <ApiResponse>({ status: res.status, payload: res, message: '' });
      })
      .catch(this.catchBadResponse);
  }

  private buildApiUrl(url: string): string {
    return `${this.apiUrl}/${url}`;
  }

  private initHeaders(): Headers {
    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    return headers;
  }

  private catchBadResponse: (errorResponse: any) => Observable<any> = (errorResponse: any) => {
    const res = <Response>errorResponse;
    let emsg = `${res.statusText}: ${res.toString()}` || 'unknown error';

    if (res.status === 401) {

      // Session is valid, but user can't access that feature
      console.error('Error (Unauthorized) ->', emsg, errorResponse);
      this.router.navigate(['d']);

    } else if (res.status === 403) {

      // Session has expired, token invalid or token missing
      this.router.navigate(['login'], { queryParams: { logout: 1 } });
      this.notifierService.activateSimple(NotifierMessageType.Error, 'ERRORS.SESSIONEXPIRED');
      console.error('Error (Session Expired) ->', emsg, errorResponse);
      return Observable.of({ status: res.status, payload: {}, message: '' });

    } else if (res.status >= 400 && res.status <= 499) {

      // Back-end failed with an user friendly exception
      const err = res.json();
      emsg = err.message ? err.message : JSON.stringify(err);
      this.notifierService.activateSimple(NotifierMessageType.Warning, emsg);
      console.error('Error (Bad Request) ->', emsg, errorResponse);

    } else {
      // Something very bad and unexptected happened.
      this.notifierService.activateSimple(NotifierMessageType.Error, errorResponse._body);
    }

    // Throw another error
    const response = <ApiResponse>({ status: res.status, payload: res, message: emsg, alreadyShown: true });
    return Observable.throw(response);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/global.service.ts